var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 16.933",
    id: "RarFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.968,
    transform: "matrix(1.03366 0 0 1.03333 -2.911 3.935)",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.9217235,-3.8085938 A 0.25603411,0.25603411 0 0 0 4.6658641,-3.5527344 V 12.322266 a 0.25603411,0.25603411 0 0 0 0.2558594,0.255859 H 17.093598 a 0.25603411,0.25603411 0 0 0 0.255859,-0.255859 V 1.3886719 a 0.25603411,0.25603411 0 0 0 -0.07227,-0.1796875 l -4.796875,-4.9179688 v -0.00195 a 0.25600851,0.25600851 0 0 0 -0.01953,-0.019531 0.25600851,0.25600851 0 0 0 -0.02149,-0.019531 0.25600851,0.25600851 0 0 0 -0.02344,-0.017578 0.25600851,0.25600851 0 0 0 -0.02344,-0.013672 0.25600851,0.25600851 0 0 0 -0.01367,-0.00586 0.25600851,0.25600851 0 0 0 -0.02539,-0.00977 0.25600851,0.25600851 0 0 0 -0.01367,-0.00391 0.25600851,0.25600851 0 0 0 -0.0059,0 0.25600851,0.25600851 0 0 0 -0.03711,-0.00586 0.25600851,0.25600851 0 0 0 -0.01367,-0.00195 0.25600851,0.25600851 0 0 0 -0.0059,0 h -0.0078 z m 0.2558594,0.5117188 h 6.9902341 l 4.669922,4.7890625 V 12.066406 H 5.1775829 Z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.269531 -3.8085938 A 0.25603411 0.25603411 0 0 0 12.021484 -3.5527344 L 12.021484 1.3886719 A 0.25603411 0.25603411 0 0 0 12.277344 1.6445312 L 17.09375 1.6445312 A 0.25603411 0.25603411 0 0 0 17.277344 1.2089844 L 12.460938 -3.7304688 A 0.25603411 0.25603411 0 0 0 12.269531 -3.8085938 z M 12.533203 -2.921875 L 16.488281 1.1328125 L 12.533203 1.1328125 L 12.533203 -2.921875 z ",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 2,
      InkscapeFontSpecification: "Calibri",
      textAlign: "center"
    },
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    "aria-label": "RAR",
    fontFamily: "Calibri",
    fontSize: 5.292,
    opacity: 0.99,
    textAnchor: "middle",
    className: "colorStroke000000 svgStroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437ef7",
    stroke: "none",
    d: "M6.6153573 15.09727q0 .02067-.00775.03617-.00775.0155-.03359.02584-.025838.01034-.072347.0155-.046509.0052-.1240235.0052-.067179 0-.1111044-.0052-.041341-.0052-.067179-.0155-.025838-.01292-.041341-.03359-.012919-.02067-.023254-.05168L5.8272912 14.28595Q5.773031 14.151591 5.713603 14.040487 5.6567589 13.926798 5.5766604 13.8467 5.4965619 13.764018 5.3880413 13.720093 5.2795207 13.673584 5.1270752 13.673584H4.8299355v1.423686q0 .02067-.012919.03617-.010335.0155-.036174.02584-.023254.0078-.067179.01292-.041341.0078-.1059368.0078-.064596 0-.1085206-.0078-.041341-.0052-.067179-.01292-.025838-.01033-.036173-.02584-.010335-.0155-.010335-.03617v-3.09542q0-.100769.051677-.139526.05426-.04134.1136882-.04134H5.261434q.1266073 0 .2092897.0078.085266.0052.1524455.01292.1937868.03359.3410647.105937.1498617.07235.2506308.183451.1007691.111105.1498618.255799.051676.14211.051676.315226 0 .167949-.046509.302308-.043925.131775-.1291911.235127-.085266.10077-.2041221.1757-.1188558.07493-.2661338.126608.082682.03617.1498618.09302.067179.05426.1240235.131775.059428.07752.1111044.178284.051676.100769.1033529.227377l.2997235.736389q.036173.09302.046509.131775.010335.03617.010335.05684zM5.9461471 12.748575q0-.196371-.08785-.330729-.08785-.136943-.2945558-.196371-.064596-.01809-.1472779-.02584-.080099-.0078-.2118735-.0078H4.8299355v1.126547h.4340823q.1757 0 .3023073-.04134.1291912-.04393.2144573-.118856.085266-.07751.1240235-.180867.041341-.103353.041341-.224793zM9.762454 15.006836q.02067.05685.02067.09302.00258.03359-.018087.05168-.020671.01809-.069763.02325-.046509.0052-.1266074.0052-.080099 0-.1291911-.0052-.046509-.0026-.072347-.01033-.023254-.01034-.036174-.02584-.010335-.0155-.020671-.03876L9.0234805 14.28595H7.6333837l-.2738853.803569q-.00775.02325-.020671.04134-.012919.0155-.038757.02842-.023254.01034-.069763.0155-.043925.0052-.1162721.0052-.074931 0-.1240235-.0078-.046509-.0052-.067179-.02325-.018087-.01809-.018087-.05168.00258-.03617.023254-.09302l1.1213793-3.105756q.010335-.02842.025838-.04651.018087-.01809.049093-.02842.03359-.01033.082682-.01292.051676-.0052.1291912-.0052.082682 0 .1369426.0052.05426.0026.08785.01292.03359.01034.051676.03101.018087.01809.028422.04651zM8.3232644 12.2654h-.00258l-.5761925 1.666566h1.1627204zM12.547815 15.09727q0 .02067-.0078.03617-.0078.0155-.03359.02584-.02584.01034-.07235.0155-.04651.0052-.124023.0052-.06718 0-.111105-.0052-.04134-.0052-.06718-.0155-.02584-.01292-.04134-.03359-.01292-.02067-.02326-.05168L11.759749 14.28595q-.05426-.134359-.113688-.245463-.05684-.113689-.136943-.193787-.0801-.08268-.188619-.126607-.10852-.04651-.260966-.04651h-.29714v1.423686q0 .02067-.01292.03617-.01033.0155-.03617.02584-.02325.0078-.06718.01292-.04134.0078-.105936.0078-.0646 0-.108521-.0078-.04134-.0052-.06718-.01292-.02584-.01033-.03617-.02584-.01033-.0155-.01033-.03617v-3.09542q0-.100769.05168-.139526.05426-.04134.113689-.04134h.710551q.126607 0 .20929.0078.08527.0052.152445.01292.193787.03359.341065.105937.149862.07235.250631.183451.100769.111105.149861.255799.05168.14211.05168.315226 0 .167949-.04651.302308-.04393.131775-.129191.235127-.08527.10077-.204122.1757-.118856.07493-.266134.126608.08268.03617.149862.09302.06718.05426.124023.131775.05943.07752.111105.178284.05168.100769.103353.227377l.299723.736389q.03617.09302.04651.131775.01033.03617.01033.05684zm-.66921-2.348695q0-.196371-.08785-.330729-.08785-.136943-.294556-.196371-.0646-.01809-.147278-.02584-.0801-.0078-.211873-.0078h-.374655v1.126547h.434083q.1757 0 .302307-.04134.129191-.04393.214457-.118856.08527-.07751.124024-.180867.04134-.103353.04134-.224793z",
    fontWeight: 400,
    className: "color000000 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRar);
export default __webpack_public_path__ + "static/media/rar.5de014b81b032748213a05a8b38b7df5.svg";
export { ForwardRef as ReactComponent };